import { LoadableRoute } from 'routes/utils/loadable';

export const UserProfileContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "UserProfile" */ './UserProfile'),
});
